export default {
  manageObjectDraggingProblemsInMoble: function () {
    let startPosition = 0
    document.addEventListener(
      'touchmove',
      function (e) {
        if (e.target.parentNode.id === 'stepCaption') {
          let TO = 100
          let endPosition = e.changedTouches[0].clientY
          if (startPosition < endPosition + 5) {
            TO = 0
          }
          e.target.parentNode.parentNode.scrollTo({
            top: TO,
            behavior: 'smooth'
          })
        }
        if (
          e.target.parentNode.parentNode.id !== 'stepListScrollable' &&
          e.target.parentNode.parentNode.id !== 'collectionList'
        ) {
          e.preventDefault()
        }
      },
      { passive: false }
    )

    document.addEventListener(
      'touchstart',
      function (e) {
        startPosition = e.touches[0].clientY
      },
      { passive: false }
    )
  },

  isDeviceTouchable: function () {
    if ('ontouchstart' in window) {
      return true
    }

    if (window.DocumentTouch && document instanceof DocumentTouch) {
      return true
    }

    return window.matchMedia('(pointer: coarse)').matches
  },

  fixSizeOnMobileDevices: function () {
    document.body.style.height = window.innerHeight.toString() + 'px'
    document.body.style.width = window.innerWidth.toString() + 'px'
    const mainContainer = document.getElementById('mainContainer')
    mainContainer.style.height = window.innerHeight.toString() + 'px'
    mainContainer.style.width = window.innerWidth.toString() + 'px'
  }
}
